// AUTO-GENERATED z Notion DB "DAIEN Blog CMS" przez scripts/fetch-blog-from-notion.mjs
// Nie edytuj recznie - zmiany pisz w Notion, build pobierze swieze.

import type { PostMeta } from './registry';

export const meta: PostMeta = {
    "slug": "witaj-na-blogu-daien",
    "title": "Witaj na blogu co tu znajdziesz",
    "date": "2026-05-10",
    "excerpt": "Krotkie wprowadzenie do tego, czym ten blog jest, dla kogo i jakie tematy bede poruszac. Bez sciemy o \"AI rewolucji\".",
    "tags": [
      "Meta",
      "Wstep"
    ],
    "readTime": 3
  };

export function Body() {
  return (
    <>
      <p>Hej. Jestem Dawid i prowadze DAIEN - buduje systemy AI dla firm B2B, ktore zamiast skalowac zatrudnieniem, chca skalowac automatyzacja. Lead gen, voice agents 24/7, customer support RAG, workflow w n8n.</p>
      <p>Ten blog jest po to, zeby pokazac jak naprawde wyglada wdrozenie AI w realnej polskiej firmie - bez slajdow z konferencji, bez "rewolucji za chwile", bez ChatGPT-przewodnikow "10 promptow ktore zmienia twoj biznes".</p>
      <h2>Co tu znajdziesz</h2>
      <ul>
        <li><strong>Case studies</strong> - historie wdrozen (Kognita, klient z branzy deweloperskiej, klient e-commerce 3-spolkowy) z konkretnymi liczbami i co sie zepsulo.</li>
        <li><strong>Stack i decyzje</strong> - dlaczego wybieram n8n nad Zapier, dlaczego Retell nad Vapi, kiedy Claude vs GPT-4.</li>
        <li><strong>Antypatterns</strong> - co nie zadzialalo, czego nie radze robic, bledy ktore kosztowaly mnie tysiace.</li>
        <li><strong>FAQ od klientow</strong> - pytania ktore dostaje na rozmowach (cennik, czas wdrozenia, ROI).</li>
      </ul>
      <h2>Czego tu nie bedzie</h2>
      <ul>
        <li>Listicle "5 sposobow jak AI zmieni twoja firme".</li>
        <li>Promotion stack jako srebrnej kuli - kazde narzedzie ma trade-offy.</li>
        <li>Cudzych success stories z LinkedIn - tylko wlasne wdrozenia z dostepem do produkcyjnych metryk.</li>
      </ul>
      <p>Pierwsze trzy posty pojawia sie w przeciagu dwoch tygodni. Jesli masz pytanie do tematu - napisz na <a href="mailto:dawid@daien.pl" target="_blank" rel="noopener">dawid@daien.pl</a> albo zostaw wiadomosc przez <a href="/#kontakt">formularz</a>. Tematy ktore wracaja najczesciej, ladujA na blogu jako pierwsze.</p>
    </>
  );
}
